<template>
    <div style="outline: 1px solid #BEBEBE; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
      <div class="pull-right">
        <button type="button" style="font-size: 20;" class="close" aria-label="Usuń"  @click="removeImage(image)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-row  justify-content-right"> 
        <div class="form-group col-md-3"> 

        </div>
        <div class="form-group col-md-6">
          <img v-if="(image.imageData)" :src="image.imageData" style="max-width:500px; max-height=500px;" />
        </div>
        <div class="form-group col-md-3 align-self-center">
          <div class="form-row" style="margin-top: 10px; margin-bottom: 10px;">
            <button type="button" @click="imageUp" class="btn btn-default">
              <span style="font-size: 50px;">&#8593;</span>
            </button>
          </div>
          <div class="form-row" style="margin-top: 10px; margin-bottom: 10px;">
            <button type="button" @click="imageDown" class="btn btn-default">
               <span  style="font-size: 50px;" >&#8595;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="form-row justify-content-center" style="margin-top: 15px;">
         <div class="form-group col-md-6">
          <label for="descriptionPL">Opis PL</label>
          <input
            type="text"
            class="form-control"
            id="descriptionPL"
            v-model="image.descriptionPL"
            maxlength="200"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="descriptionDE">Opis DE</label>
          <input
            type="text"
            class="form-control"
            id="descriptionDE"
            v-model="image.descriptionDE"
            maxlength="200"
          />
        </div>
      </div>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Modal from "./Modal";
import PictureInput from 'vue-picture-input';
import FileReader from 'vue-filereader';

export default {
  name: 'buildingImage',
  components: {
  },
  props: ['image'],
  data: function() {
    return {}
  },
  methods: {
    removeImage(image) {
       this.$emit('remove-image', image);
    },
    imageDown(image) {
       this.$emit('down-image', image);
    },
    imageUp(image) {
       this.$emit('up-image', image);
    },
    handleImage(image, e){
      image.imageData = e;  
    },
    created(){
      this.$refs.pictureInput.image = this.image.imageData;
    },
    onChange() {
        console.log("Picture changed!")
        if (this.$refs.pictureInput.file) {
            this.image = this.$refs.pictureInput.file;
          } else {
            console.log("Old browser. No support for Filereader API");
          }
      }
  },
};
</script>